"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkEmailExistFixtures = void 0;
exports.checkEmailExistFixtures = {
    hasError: false,
    isLoading: false,
    isValid: true,
    userExist: false
};
